import { Component, TemplateRef, OnInit, AfterViewInit, DoCheck } from '@angular/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { AuthService } from 'src/app/auth/services/auth.service';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, DoCheck {
  modalRef: any;
  currentUser: any;

  // 🔹 Existing properties
  isContractDropDownVisible = false;
  isContractDetailsActive = false;
  currentRoute: string;
  activeContractTab: string = ''; // Default tab

  constructor(
    private modalService: BsModalService,
    private authService: AuthService,
    public router: Router,
  ) {
    this.isDropDownVisible = false
    this.isDropDownVisible1 = false
    this.isManageReportedContentActive = false
    this.currentRoute = this.router.url;
    if(this.currentRoute?.includes('?')){
      this.currentRoute = this.currentRoute.split('?')[0]
    }
    this.isManageReportedContentActive1 = false
  }
  isActive1(url: string): boolean {
    return this.router.url === url || this.router.url.startsWith(url);

  }


  isReportedUsersActive: boolean = false;

  
  isMenuOpen:false
  isDropDownVisible: boolean;
  isDropDownVisible1: boolean;
  isManageReportedContentActive: boolean

  isManageReportedContentActive1: boolean

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;

    this.checkUlr();
   
  }

  ngDoCheck() {
    if (window.location.pathname.indexOf('coupon') != -1) {
      document.getElementById('couponmenu').scrollIntoView();
    } else if (window.location.pathname.indexOf('coordinates') != -1) {
      document.getElementById('Coordinates').scrollIntoView();
    } else if (window.location.pathname.indexOf('notifications') != -1) {
      // document.getElementById('notifications').scrollIntoView();
    } else if (window.location.pathname.indexOf('event-sponsors') != -1) {
      document.getElementById('Sponsors').scrollIntoView();
    } else if (window.location.pathname.indexOf('treasure') != -1) {
      document.getElementById('Treasure').scrollIntoView();
    } else if (window.location.pathname.indexOf('more-sections') != -1) {
      document.getElementById('More-Section').scrollIntoView();
    } else if (window.location.pathname.indexOf('home-partners') != -1) {
      document.getElementById('home-partners').scrollIntoView();
    }
  }



  onClickDrop(){
  this.isDropDownVisible =true;
}

checkUlr(){
  let x  = setInterval(() => {
    let currentRoute = this.router.url;
    if(currentRoute === '/customer-submission' ||  currentRoute === '/product-details'  ){
      this.isDropDownVisible = true;
      clearInterval(x);
    }
  }, 10);
}



  logout() {
    this.modalRef.hide();
    this.authService.logout({ id: this.currentUser.id }).subscribe((res: any) => {
      if (res) {
        localStorage.removeItem("currentUser");
        this.router.navigateByUrl("/auth/login");
      }
    });
  }

  // 🔹 Modal logout confirmation
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  confirm() {
    this.logout();
  }
  cancel() {
    this.modalRef.hide();
  }
}
